import AlertModal from '@/components/ux/AlertModal/AlertModal';
import { adminUtils, capturePosthogEvent, log } from '@/helpers';
import { CampaignTag } from '@/legacy-types';
import { useCampaignTagsStore } from '@/stores/campaigns/useCampaignTagsStore';
import { Dropdown, DropdownItem, Flex, Icon, type IconProps, Typography, useToast } from '@alpine-iq/ui-library';
import React from 'react';
import { useCampaignTagDrawerStore } from './CampaignTagDrawer';

type CampaignTagMoreProps = {
	id?: string;
	close?: () => void;
	tag?: CampaignTag;
	color?: string;
};

export default function CampaignTagMore(props: CampaignTagMoreProps) {
	const { addToast } = useToast();
	const { deleteCampaignTag } = useCampaignTagsStore();
	const { setOpenTagID } = useCampaignTagDrawerStore();

	const [openAlertModal, setOpenAlertModal] = React.useState(false);

	const tag = props.tag;

	type DropdownItemTypes = {
		label: string;
		icon?: IconProps['type'];
		onClick: (close: () => void) => void;
		css?: string;
		shown?: boolean;
	};

	const dropdownItems: DropdownItemTypes[] = React.useMemo(() => {
		return (
			[
				{
					label: 'Edit',
					onClick: (close: () => void) => {
						close();
						log('edit tag', tag?.id);
						capturePosthogEvent('Campaign Tag - Edit');
						setOpenTagID(tag?.id);
					},
					shown: !!tag?.id,
				},
				{
					label: 'Delete',
					onClick: (close: () => void) => {
						close();
						if (!tag?.id) return;
						capturePosthogEvent('Campaign Tag - Delete Initial');
					},
					shown: !!tag?.id,
				},
			] as DropdownItemTypes[]
		).filter((item) => item.shown !== false);
	}, [tag]);

	if (!tag?.id) return null;

	return (
		<>
			<AlertModal
				open={openAlertModal}
				onConfirm={() => {
					capturePosthogEvent('Campaign Tag - Delete');
					if (!tag?.id) return;
					deleteCampaignTag(tag.id);
					setOpenAlertModal(false);
				}}
				onClose={() => setOpenAlertModal(false)}
			/>

			<div
				css={`
					.dispense-dropdown-menu {
						top: calc(100% + 18px);
						min-width: 200px;
					}
				`}
			>
				<Dropdown
					usePortal
					Trigger={({ toggleDropdown }) => {
						return (
							<Flex
								style={{ cursor: 'pointer' }}
								onClick={(e) => {
									e.stopPropagation();
									e.preventDefault();
									toggleDropdown();
									capturePosthogEvent('Campaign Tag - Prompt More', {
										tagID: tag?.id,
									});
								}}
							>
								<Icon
									type="MORE"
									color={props.color}
									height={16}
									width={16}
								/>
							</Flex>
						);
					}}
					position="right"
				>
					{({ close }) => (
						<>
							{dropdownItems.map((item) => (
								<DropdownItem
									key={item.label}
									onClick={(e) => {
										console.log('dropdown item clicked', item.label);
										e.preventDefault();
										e.stopPropagation();
										item.onClick(close);
									}}
									css={item.css}
								>
									<Flex align="center">
										{item.icon && (
											<Icon
												type={item.icon}
												size="small"
											/>
										)}
										<Typography style={{ color: 'inherit' }}>{item.label}</Typography>
									</Flex>
								</DropdownItem>
							))}
						</>
					)}
				</Dropdown>
			</div>
		</>
	);
}
